import { ColumnDef } from '@tanstack/react-table';
import type { SocialAccountData } from '../social-accounts-table/social-accounts-table-types';

export const topSocialAccountsColumns: ColumnDef<SocialAccountData>[] = [
  {
    accessorKey: 'socialAccount',
    header: 'Top Creators',
    meta: { className: 'text-left', headerClassName: 'text-left' },
    size: 220,
  },
  {
    accessorKey: 'memberName',
    header: 'Member',
    meta: { className: 'text-left', headerClassName: 'text-left' },
    size: 200,
  },
  {
    accessorKey: 'impressions',
    header: 'Impressions',
    enableSorting: true,
    meta: { className: 'text-right', headerClassName: 'text-right' },
  },
  {
    accessorKey: 'clicks',
    header: 'Clicks',
    meta: { className: 'text-right', headerClassName: 'text-right' },
  },
  {
    accessorKey: 'reach',
    header: 'Reach',
    meta: { className: 'text-right', headerClassName: 'text-right' },
  },
  {
    accessorKey: 'sales',
    header: 'Sales',
    meta: { className: 'text-right', headerClassName: 'text-right' },
  },
  {
    accessorKey: 'spend',
    header: 'Spend',
    meta: { className: 'text-right', headerClassName: 'text-right' },
  },
];
